import { TextKey } from '@mews-commander/enums';
import { createAddFormConnect } from '../../../entityManagement';
import { addRelatedContact } from '../../actions';
import CustomerForm from './CustomerForm';

export default createAddFormConnect({
    titleKey: TextKey.AddNewCustomer,
    addAction: addRelatedContact,
    submitButtonKey: TextKey.Add,
})(CustomerForm);
